import React, { useEffect, useState } from 'react';
import { useBranding } from '../contexts/BrandingContext';

import {
  useHelp
} from './HelpContext';

import {
  HELP_ARTICLES,
  HELP_SECTIONS
} from './helpArticles';

import './help.css';

export default function HelpDrawer() {

  const {
    isOpen,
    topic,
    setTopic,
    closeHelp
  } = useHelp();
  const { branding, loading } = useBranding();
  const brandName = branding?.brandName || 'EveryID';



  const article = HELP_ARTICLES[topic];
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
  if (loading)
    return;


  const article =
    HELP_ARTICLES[topic];

  if (!article?.file) {

    setHtmlContent('');
    return;

  }

  fetch(`/help/${article.file}`)
    .then(r => r.text())
    .then(html => {
      html = html.replaceAll('{{brandName}}', brandName);
      setHtmlContent(html);

      setTimeout(() => {

        const el =
          document.querySelector(
            '.help-content'
          );

        if (el) {

          el.scrollTop = 0;

        }

      }, 0);

    })
    .catch(err => {

      console.error(
        'Failed loading help file',
        err
      );

      setHtmlContent('<p>Unable to load help content.</p>');

    });

}, [topic, brandName, loading]);


if (!isOpen)
  return null;


  return (

    <div className="help-overlay">

      <div className="help-drawer">

        <div className="help-header">

          <h2>
            Help
          </h2>

          <button
            onClick={closeHelp}
          >
            ✕
          </button>

        </div>

        <div className="help-body">

        <div className="help-nav">

          {HELP_SECTIONS.map(section => (

            <div
              key={section.section}
            >

              <div
                className="help-section"
              >
                {section.section}
              </div>

              {section.items.map(
                key => {

                  const article =
                    HELP_ARTICLES[key];

                  return (
                    <div
                      key={key}
                      className="help-topic"
                      onClick={() =>
                        setTopic(key)
                      }
                    >
                      {article?.title.replaceAll('{{brandName}}', brandName)}
                    </div>
                  );

                }
              )}

            </div>

          ))}

        </div>
          <div className="help-content">

            <div
              className="help-article"
              dangerouslySetInnerHTML={{
                __html: htmlContent
              }}
            />

            {!!article?.related?.length && (
              <>
                <h4>
                  Related Topics
                </h4>

                {article.related.map(
                  rel => (

                    <div
                      key={rel}
                      className="help-related"
                      onClick={() =>
                        setTopic(rel)
                      }
                    >
                      {
                        HELP_ARTICLES[
                          rel
                        ]?.title
                      }
                    </div>

                  )
                )}

              </>
            )}

          </div>

        </div>

      </div>

    </div>

  );

}
